// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tournament-grid_TournamentGrid__5Hf6z{
    display: flex;
    flex-direction: column;
    min-height: 0px;
    flex: 1 1;

    >div:nth-child(1) >div >div{
        overflow: auto !important;
        >div {
            justify-content: start;
        }
    }
}
.tournament-grid_EditorFrame__4zlW\\+{
    display: grid;
    grid-template-columns: 6fr 6fr;
    min-height: 0px;
    flex: 1 1;
    overflow-y: auto;
}
.tournament-grid_Cards__\\+wD0w > * {
    margin: 30px;
}
.tournament-grid_LeftHemiScreen__IWR\\+E{
    background: aquamarine;
}
.tournament-grid_RightHemiScreen__bXvzW{
    background: antiquewhite;
}
.tournament-grid_TableBar__8yo4E{
    display: flex;
}
.tournament-grid_GamerTable__uMIg4{
    display: flex;
    flex-direction: column;
}
.tournament-grid_GamerTableRow__3T4GW{
    display: flex;
    flex-direction: row;
}
.tournament-grid_GamerTableRow__3T4GW > *{
    margin: 10px;
}
.tournament-grid_GamerTableRow__3T4GW:hover {
    background: rgba(210, 210, 210, 0.1);
}

.tournament-grid_PlayersListContainer__uvysu{
    max-width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/pages/TournamentsPageN/ui/tournament-grid.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,eAAe;IACf,SAAO;;IAEP;QACI,yBAAyB;QACzB;YACI,sBAAsB;QAC1B;IACJ;AACJ;AACA;IACI,aAAa;IACb,8BAA8B;IAC9B,eAAe;IACf,SAAO;IACP,gBAAgB;AACpB;AACA;IACI,YAAY;AAChB;AACA;IACI,sBAAsB;AAC1B;AACA;IACI,wBAAwB;AAC5B;AACA;IACI,aAAa;AACjB;AACA;IACI,aAAa;IACb,sBAAsB;AAC1B;AACA;IACI,aAAa;IACb,mBAAmB;AACvB;AACA;IACI,YAAY;AAChB;AACA;IACI,oCAAoC;AACxC;;AAEA;IACI,eAAe;AACnB","sourcesContent":[".TournamentGrid{\n    display: flex;\n    flex-direction: column;\n    min-height: 0px;\n    flex: 1;\n\n    >div:nth-child(1) >div >div{\n        overflow: auto !important;\n        >div {\n            justify-content: start;\n        }\n    }\n}\n.EditorFrame{\n    display: grid;\n    grid-template-columns: 6fr 6fr;\n    min-height: 0px;\n    flex: 1;\n    overflow-y: auto;\n}\n.Cards > * {\n    margin: 30px;\n}\n.LeftHemiScreen{\n    background: aquamarine;\n}\n.RightHemiScreen{\n    background: antiquewhite;\n}\n.TableBar{\n    display: flex;\n}\n.GamerTable{\n    display: flex;\n    flex-direction: column;\n}\n.GamerTableRow{\n    display: flex;\n    flex-direction: row;\n}\n.GamerTableRow > *{\n    margin: 10px;\n}\n.GamerTableRow:hover {\n    background: rgba(210, 210, 210, 0.1);\n}\n\n.PlayersListContainer{\n    max-width: 100%;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"TournamentGrid": `tournament-grid_TournamentGrid__5Hf6z`,
	"EditorFrame": `tournament-grid_EditorFrame__4zlW+`,
	"Cards": `tournament-grid_Cards__+wD0w`,
	"LeftHemiScreen": `tournament-grid_LeftHemiScreen__IWR+E`,
	"RightHemiScreen": `tournament-grid_RightHemiScreen__bXvzW`,
	"TableBar": `tournament-grid_TableBar__8yo4E`,
	"GamerTable": `tournament-grid_GamerTable__uMIg4`,
	"GamerTableRow": `tournament-grid_GamerTableRow__3T4GW`,
	"PlayersListContainer": `tournament-grid_PlayersListContainer__uvysu`
};
export default ___CSS_LOADER_EXPORT___;
